import React, {Component} from 'react';
import {Col, Row} from "reactstrap";

class CustomerWarningNoEntry extends Component {

	constructor(props) {
		super(props);

		this.state = {};
	}

	setModeAsCreate() {
		this.props.setModeAsCreate();
	}

	render() {
		return (
			<Row style={{margin: '0 2% 0 2%'}}>
				<Col sm='12' className='customerWarningNoEntryCard'>
					<h5 style={{marginBottom: '5%'}}>Takip etmek isteyebileceğiniz bazı başlıklar hakkında, e-posta ve/veya SMS bildirimleri talep
						edebilirsiniz.</h5>
					<Row>
						<Col sm='4' style={{padding: '2% 0 0 0'}}>
							<hr/>
						</Col>
						<Col sm='4'>
							<span className="bell fa fa-bell"></span>
						</Col>
						<Col sm='4' style={{padding: '2% 0 0 0'}}>
							<hr/>
						</Col>
					</Row>
					<button className='customerWarningStartButton' onClick={() => this.setModeAsCreate()}>Başlamak İçin Tıklayın</button>
				</Col>
			</Row>
		)
	}
}

export default CustomerWarningNoEntry;